// Module
var code = "<div class=\"saving-indicator\" layout layout-align=\"center center\"> <div ng-if=\"ctrl.saveState\" class=\"saving-message enter-fade\" ng-class=\"{'ck-warn': ctrl.saveState === ctrl.SAVE_ERROR || ctrl.saveState === ctrl.SAVE_ERROR_STUDENT_DUPLICATE}\"> {{ctrl.saveMessage}} </div> </div> ";
// Exports
module.exports = code;